import http from './http'

export function login(payload) {
  return http.post('/auth/login', payload)
}

export function syncSession() {
  return http.post('/auth/session', {}, { skipAuthRedirect: true })
}

export function logout() {
  return http.post('/auth/logout', {}, { skipAuthRedirect: true })
}

export function register(payload) {
  return http.post('/auth/register', payload)
}

export function completeGoogle(payload) {
  return http.post('/auth/google/complete', payload)
}

export function googleAuthURL(redirect = '/dashboard') {
  const params = new URLSearchParams()
  if (redirect) params.set('redirect', redirect)
  const query = params.toString()
  return `/api/v1/auth/google${query ? `?${query}` : ''}`
}
